import { render } from "./MdSnackbar.vue?vue&type=template&id=58ae2d39&scoped=true&ts=true"
import script from "./MdSnackbar.vue?vue&type=script&lang=ts"
export * from "./MdSnackbar.vue?vue&type=script&lang=ts"

import "./MdSnackbar.vue?vue&type=style&index=0&id=58ae2d39&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ae2d39"]])

export default __exports__